import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-653c7fea")

_pushScopeId("data-v-653c7fea")
const _hoisted_1 = { class: "flex flex--width flex--v flex--gap-20" }
const _hoisted_2 = {
  key: 0,
  class: "text text--accent-gray-b text--size-18 text--semi-bold text--center"
}
const _hoisted_3 = { class: "flex flex--v flex--gap-20" }
const _hoisted_4 = { class: "flex flex--v flex--gap-5" }
const _hoisted_5 = {
  for: "email",
  class: "form-label"
}
const _hoisted_6 = { class: "flex flex--v flex--gap-5" }
const _hoisted_7 = {
  for: "password",
  class: "form-label"
}
const _hoisted_8 = { class: "form-check" }
const _hoisted_9 = {
  class: "form-check-label",
  for: "checkboxRememberMe"
}
const _hoisted_10 = { class: "flex flex--width flex--v flex--valign-c flex--gap-20" }
const _hoisted_11 = { class: "flex flex--v flex--valign-c flex--gap-10" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BreezeValidationErrors = _resolveComponent("BreezeValidationErrors")
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_InertiaLink = _resolveComponent("InertiaLink")
  const _component_Plane = _resolveComponent("Plane")
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    title: _ctx.$trans('auth.login'),
    gap: false
  }, {
    default: _withId(() => [
      _createVNode(_component_Plane, {
        class: "login-plane",
        darker: true
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_BreezeValidationErrors),
            (_ctx.status)
              ? (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString(_ctx.status), 1))
              : _createCommentVNode("", true),
            _createVNode("form", {
              class: "full-width",
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$trans("auth.email")), 1),
                  _withDirectives(_createVNode("input", {
                    id: "email",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.email = $event)),
                    name: "email",
                    type: "email",
                    class: "form-control",
                    required: "",
                    autofocus: "",
                    autocomplete: "username"
                  }, null, 512), [
                    [_vModelText, _ctx.form.email]
                  ])
                ]),
                _createVNode("div", _hoisted_6, [
                  _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$trans("auth.password")), 1),
                  _withDirectives(_createVNode("input", {
                    id: "password",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.password = $event)),
                    name: "password",
                    type: "password",
                    class: "form-control",
                    required: "",
                    autocomplete: "current-password"
                  }, null, 512), [
                    [_vModelText, _ctx.form.password]
                  ])
                ]),
                _createVNode("div", _hoisted_8, [
                  _withDirectives(_createVNode("input", {
                    id: "checkboxRememberMe",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.remember = $event)),
                    class: "form-check-input",
                    name: "remember",
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.remember]
                  ]),
                  _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$trans("auth.remember_me")), 1)
                ]),
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_GenericButton, {
                    class: "login-button",
                    title: _ctx.$trans('auth.login'),
                    disabled: _ctx.form.processing,
                    onClick: _ctx.submit
                  }, null, 8, ["title", "disabled", "onClick"]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode(_component_InertiaLink, {
                      href: _ctx.route('register'),
                      class: "inertia-link text text--less-gap text--primary-b text--size-16 text--center"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$trans("auth.not_registered")), 1)
                      ]),
                      _: 1
                    }, 8, ["href"]),
                    (_ctx.canResetPassword)
                      ? (_openBlock(), _createBlock(_component_InertiaLink, {
                          key: 0,
                          href: _ctx.route('password.request'),
                          class: "inertia-link text text--less-gap text--primary-b text--size-16 text--center"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.$trans("auth.forgot_password")), 1)
                          ]),
                          _: 1
                        }, 8, ["href"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 32)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
})